import { Component, OnInit, inject } from '@angular/core';
import {Location} from '@angular/common';
import {ActivatedRoute} from "@angular/router";
import {GameService} from "../../services/game.service";
import {GamePlay} from "../../model/game-play";
import {ODK} from "../../model/odk";
import { AbstractControl, FormControl, FormGroup, ValidationErrors, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import {Down} from "../../model/down";
import {Hash} from "../../model/hash";
import {PlayType} from "../../model/playType";
import {PlayResult} from "../../model/playResult";
import {GameStatus} from "../../model/gameStatus";
import {MatSnackBar} from "@angular/material/snack-bar";
import { TranslocoService, TranslocoModule } from "@ngneat/transloco";
import {captureMessageWithTags} from "../../../sentry/sentry";
import {PenTeam} from "../../model/penTeam";
import {MessageDialogService} from "../../services/message-dialog.service";
import {GamePlayService} from "../../services/game-play.service";
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-game-play-edit',
    templateUrl: './game-play-edit.component.html',
    styleUrls: ['./game-play-edit.component.scss'],
    imports: [MatButton, FormsModule, ReactiveFormsModule, TranslocoModule]
})
export class GamePlayEditComponent implements OnInit{
  private route = inject(ActivatedRoute);
  game = inject(GameService);
  private location = inject(Location);
  private gamePlayService = inject(GamePlayService);
  private _snackBar = inject(MatSnackBar);
  private translocoService = inject(TranslocoService);
  private messageDialog = inject(MessageDialogService);

  gamePlayNumber!: number
  editedGamePlay?: GamePlay
  gamePlayForm?: FormGroup;
  newPlay = false;

  odkEnum: any = ODK;
  odkKeys = Object.keys(ODK).filter(key => isNaN(Number(key)));

  hashEnum: any = Hash;
  hashKeys = Object.keys(Hash).filter(key => isNaN(Number(key)));

  qtrEnum = [1,2,3,4,5]

  playTypeEnum: any = PlayType;
  playTypeKeys = Object.keys(PlayType).filter(key => isNaN(Number(key)));

  playResultEnum: any = PlayResult;
  playResultKeys = Object.keys(PlayResult).filter(key => isNaN(Number(key)));

  penTeamEnum:any = PenTeam;
  penTeamKeys = Object.keys(PenTeam).filter(key => isNaN(Number(key)));

  ngOnInit() {
    const gamePlayNumberParam = this.getParamGamePlayID();

    //check if the gamePlayNumber has b in it if yes new Added gamePlay after the last gamePlay
    if (gamePlayNumberParam.toString().includes('b')) {
      this.newPlay = true
      //Remove the B at the end of the gamePlayNumber
      this.gamePlayNumber = parseInt(gamePlayNumberParam.toString().replace('b', ''));

    } else {
      this.gamePlayNumber = parseInt(gamePlayNumberParam);
    }

    this.editedGamePlay = this.game.gamePlayList.find(gamePlay => gamePlay.gamePlayNumber === this.gamePlayNumber);
    if (!this.editedGamePlay) {
      captureMessageWithTags(
        `Impossible d'éditer le gamePlay. gamePlayNumber "${this.gamePlayNumber}" non trouvé.`,
        {gameId: this.game.game?.id, gamePlayNumber: this.gamePlayNumber}
      );
      this.messageDialog.openMessage(
        'validation.warningTitle',
        'validation.warningGamePlayNotFound',
        'validation.continue',
        'warning'
      );
      this.back();
      return;
    }

    if (this.newPlay) {
      this.gamePlayForm = new FormGroup({
        odk: new FormControl(ODK.Others, [Validators.required, this.isInODK]),
        down: new FormControl(null, this.isInDOWN),
        distance: new FormControl(null, [Validators.required]),
        yardLine: new FormControl('', [Validators.required]),
        hash: new FormControl(this.editedGamePlay.hash,[Validators.required, this.isInHash]),
        qtr: new FormControl(this.editedGamePlay.qtr, [Validators.required]),
        playType: new FormControl(PlayType.Missing, [Validators.required, this.isInPlayType]),
        result: new FormControl(PlayResult.Missing, [Validators.required, this.isInPlayResult]),
        gnLs: new FormControl(null),
        penTeam: new FormControl(''),
        penYards: new FormControl(null),
        kickYards: new FormControl(null),
        returnYards: new FormControl(null),
        rusher: new FormControl(null,[Validators.max(99)]),
        passer: new FormControl(null,[Validators.max(99)]),
        receiver: new FormControl(null, [Validators.max(99)]),
        tackler1: new FormControl(null, [Validators.max(99)]),
        tackler2: new FormControl(null, [Validators.max(99)]),
        battedDown: new FormControl(null,[Validators.max(99)]),
        forcedFumbleBy: new FormControl(null,[Validators.max(99)]),
        returner: new FormControl(null, [Validators.max(99)]),
        kicker: new FormControl(null, [Validators.max(99)]),
        recoveredBy: new FormControl(null, [Validators.max(99)]),
        interceptedBy: new FormControl(null, [Validators.max(99)]),
        oppRusher: new FormControl(null,[Validators.max(99)]),
        oppPasser: new FormControl(null,[Validators.max(99)]),
        oppReceiver: new FormControl(null,[Validators.max(99)]),
        oppTackler1: new FormControl(null,[Validators.max(99)]),
        oppTackler2: new FormControl(null, [Validators.max(99)]),
        oppBattedDown: new FormControl(null,[Validators.max(99)]),
        oppForcedFumbleBy: new FormControl(null,[Validators.max(99)]),
        oppReturner: new FormControl(null,[Validators.max(99)]),
        oppKicker: new FormControl(null,[Validators.max(99)]),
        oppRecoveredBy: new FormControl(null,[Validators.max(99)]),
        oppInterceptedBy: new FormControl(null,[Validators.max(99)]),
      })
      this.gamePlayNumber ++
    } else {
      this.gamePlayForm = new FormGroup({
        odk: new FormControl(this.editedGamePlay.odk, [Validators.required, this.isInODK]),
        down: new FormControl(this.editedGamePlay.down, [Validators.required, this.isInDOWN]),
        distance: new FormControl(this.editedGamePlay.distance, [Validators.required]),
        yardLine: new FormControl(this.editedGamePlay.yardLine, [Validators.required]),
        hash: new FormControl(this.editedGamePlay.hash, [Validators.required, this.isInHash]),
        qtr: new FormControl(this.editedGamePlay.qtr, [Validators.required]),


        playType: new FormControl(this.editedGamePlay.playType, [Validators.required, this.isInPlayType]),
        result: new FormControl(this.editedGamePlay.result, [Validators.required, this.isInPlayResult]),
        gnLs: new FormControl(this.editedGamePlay.gnLs),

        penTeam: new FormControl(this.editedGamePlay.penTeam),
        penYards: new FormControl(this.editedGamePlay.penYards),

        kickYards: new FormControl(this.editedGamePlay.kickYards),
        returnYards: new FormControl(this.editedGamePlay.returnYards),

        rusher: new FormControl(this.editedGamePlay.rusher,[Validators.max(99)]),
        passer: new FormControl(this.editedGamePlay.passer),
        receiver: new FormControl(this.editedGamePlay.receiver),
        tackler1: new FormControl(this.editedGamePlay.tackler1),
        tackler2: new FormControl(this.editedGamePlay.tackler2),
        battedDown: new FormControl(this.editedGamePlay.battedDown),
        forcedFumbleBy: new FormControl(this.editedGamePlay.forcedFumbleBy),
        returner: new FormControl(this.editedGamePlay.returner),
        kicker: new FormControl(this.editedGamePlay.kicker),
        recoveredBy: new FormControl(this.editedGamePlay.recoveredBy),
        interceptedBy: new FormControl(this.editedGamePlay.interceptedBy),

        oppRusher: new FormControl(this.editedGamePlay.oppRusher),
        oppPasser: new FormControl(this.editedGamePlay.oppPasser),
        oppReceiver: new FormControl(this.editedGamePlay.oppReceiver),
        oppTackler1: new FormControl(this.editedGamePlay.oppTackler1),
        oppTackler2: new FormControl(this.editedGamePlay.oppTackler2),
        oppBattedDown: new FormControl(this.editedGamePlay.oppBattedDown),
        oppForcedFumbleBy: new FormControl(this.editedGamePlay.oppForcedFumbleBy),
        oppReturner: new FormControl(this.editedGamePlay.oppReturner),
        oppKicker: new FormControl(this.editedGamePlay.oppKicker),
        oppRecoveredBy: new FormControl(this.editedGamePlay.oppRecoveredBy),
        oppInterceptedBy: new FormControl(this.editedGamePlay.oppInterceptedBy),
      });
    }
  }

  public getParamGamePlayID() {
    return this.route.snapshot.paramMap.get('id')!
  }

  save() {
    if (this.isFormValid()) {
      if (this.newPlay) {
        const gamePlay: GamePlay = this.gamePlayForm?.value;
        this.gamePlayService.insertNewPlayByPlay(this.game.game.id, gamePlay, this.gamePlayNumber).subscribe({
          next: () => {
            this.location.back();
            this.game.refreshGamePlay();
            const messageConfirmation = this.translocoService.translate('components.gamePlayEdit.saveConfirmation');
            this._snackBar.open(messageConfirmation, '', {
              horizontalPosition: 'right',
              duration: 3000
            });
          },
          error: error => {
            const messageKey = (error.status === 409)
              ? 'components.gamePlayEdit.erreur409'
              : 'components.gamePlayEdit.erreur'
            this.messageDialog.openMessage(
              'validation.errorTitle',
              messageKey,
              'app.ok',
              'error',
            )
          }
        });
      } else {
        const gamePlay = this.game.gamePlayList.find(gp => gp.gamePlayNumber === this.gamePlayNumber);
        if (!gamePlay) {
          this.messageDialog.openMessage(
            'validation.errorTitle',
            'validation.errorUnableToSavePlay',
            'app.ok',
            'error',
          )
          return
        }
        Object.assign(gamePlay, this.gamePlayForm?.value)

        this.gamePlayService.updatePlayByPlay(gamePlay.gameId!, gamePlay.id!, gamePlay).subscribe({
          next: () => {
            this.location.back();
            this.game.refreshGamePlay();

            const messageConfirmation = this.translocoService.translate('components.gamePlayEdit.saveConfirmation');
            this._snackBar.open(messageConfirmation, '', {
              horizontalPosition: 'right',
              duration: 3000
            });
          },
          error: error => {
            const messageKey = (error.status === 409)
              ? 'components.gamePlayEdit.erreur409'
              : 'components.gamePlayEdit.erreur'
            this.messageDialog.openMessage(
              'validation.errorTitle',
              messageKey,
              'app.ok',
              'error',
            )
          }
        });
      }
    }
  }

  isFormValid() {
    if (this.gamePending()) {
      return true
    }

    const controlsWithErrors = this.getControlsWithErrors(this.gamePlayForm!);
    if (controlsWithErrors.some(control => control.errors)) {
      console.log('Erreurs', controlsWithErrors.map(control => control.errors))
      this.messageDialog.openMessage(
        'validation.errorTitle',
        'validation.errorFormNotValid',
        'app.ok',
        'error',
      )
      return false
    }

    return true
  }

  gamePending(): boolean {
    const gamePlay = this.game.gamePlayList.find(gamePlay => gamePlay.gamePlayNumber === this.gamePlayNumber);
    if (!gamePlay) {
      return false
    }
    return gamePlay._status === GameStatus.Pending
  }

  back() {
    this.location.back();
  }

  isInODK(control: AbstractControl): ValidationErrors | null {
    if (!control.value) return  null
    if (Object.values(ODK).includes(control.value)) {
      return null;  // validation réussie
    } else {
      return { notInODK: true };  // échec de la validation
    }
  }

  isInDOWN(control: AbstractControl): ValidationErrors | null {
    if (!control.value) return null
    if (Object.values(Down).includes(parseInt(control.value))) {
      return null;  // validation réussie
    } else {
      return { notInDown: true };  // échec de la validation
    }
  }

  isInHash(control: AbstractControl): ValidationErrors | null {
    if (!control.value) return  null
    if (Object.values(Hash).includes(control.value)) {
      return null;  // validation réussie
    } else {
      return { notInHash: true };  // échec de la validation
    }
  }
  isInPlayType(control: AbstractControl): ValidationErrors | null {
    if (!control.value) return  null
    if (Object.values(PlayType).includes(control.value)) {
      return null;  // validation réussie
    } else {
      return { notInPlayType: true };  // échec de la validation
    }
  }
  isInPlayResult(control: AbstractControl): ValidationErrors | null {
    if (!control.value) return  null
    if (Object.values(PlayResult).includes(control.value)) {
      return null;  // validation réussie
    } else {
      return { notInPlayResult: true };  // échec de la validation
    }
  }

  getControlsWithErrors(formGroup: FormGroup): AbstractControl[] {
    let controlsWithErrors: AbstractControl[] = [];

    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      if (!control) return

      if (control instanceof FormGroup) {
        // Si le contrôle est un autre FormGroup, appeler récursivement cette fonction
        controlsWithErrors = controlsWithErrors.concat(this.getControlsWithErrors(control));
      } else if (control.errors) {
        // Si le contrôle a des erreurs, l'ajouter à la liste
        controlsWithErrors.push(control);
      }
    });

    return controlsWithErrors;
  }

  checkValue(event: any) {
    if (event.target.value > 99) {
      this.gamePlayForm?.get('rusher')?.setValue(99);
    }
  }

  odkList = [
    {
      value: ODK.Offensive,
      viewValue: 'Offensive'
    }
  ]
}
